var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-2",attrs:{"fluid":"","grid-list-sm":""}},[_c('v-card',{staticClass:"shadow-none"},[_c('v-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dcontent.data.content)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }